// extracted by mini-css-extract-plugin
export default {"result_heading":"TodayResult_result_heading__Y824b","result_heading1":"TodayResult_result_heading1__Jz5ze","para":"TodayResult_para__59POL"};